import { writable } from "svelte/store";
import { getAppConfig } from "../../../common/config/app-config";
const { encodedContextPath } = getAppConfig();

export const blogActiveFilter =  writable('');
export const blogBaseUrl =  writable(`${encodedContextPath}/blog`);
export const blogFilterHeading =  writable('');
